// extracted by mini-css-extract-plugin
export default {"contents":"iD-z","sectionHeading":"jD-z"};